export const IMPRESION_MOTOR = {
  PLANTILLA: 'PLANTILLA',
  CRYSTAL: 'CRYSTAL',
} as const;

export const IMPRESION_VARIANTE = {
  PLANTILLA_1: 'PLANTILLA_1',
  PLANTILLA_2: 'PLANTILLA_2',
} as const;

export type ImpresionMotor = (typeof IMPRESION_MOTOR)[keyof typeof IMPRESION_MOTOR];
export type ImpresionVariante = (typeof IMPRESION_VARIANTE)[keyof typeof IMPRESION_VARIANTE];

/** Extrae la ruta Crystal desde el valor legacy de Planti* (ruta libre o formato codificado). */
export function extraerRutaCrystalDesdePlanti(planti?: string | null): string {
  const raw = (planti ?? '').trim();
  if (!raw) return '';

  const upper = raw.toUpperCase();
  if (upper.startsWith(`${IMPRESION_MOTOR.CRYSTAL}|`)) {
    return raw.slice(raw.indexOf('|') + 1).trim();
  }

  if (upper.startsWith(`${IMPRESION_MOTOR.PLANTILLA}|`)) {
    const marker = `|${IMPRESION_MOTOR.CRYSTAL}|`;
    const idx = upper.indexOf(marker);
    if (idx >= 0) {
      return raw.slice(idx + marker.length).trim();
    }
    return '';
  }

  // Legacy: el campo Planti* guardaba directamente la ruta del .rpt
  return raw;
}

export type ImpresionLetraState = {
  motor: ImpresionMotor;
  variantePlantilla?: ImpresionVariante | string | null;
  rutaCrystal?: string | null;
};

/** Combina estado previo, cambio parcial y respaldo legacy sin perder rutaCrystal. */
export function mergeImpresionLetra(
  prev: ImpresionLetraState | undefined,
  next: Partial<ImpresionLetraState>,
  plantiFallback?: string | null,
): ImpresionLetraState {
  const rutaRespaldo = extraerRutaCrystalDesdePlanti(plantiFallback);
  const rutaCrystal =
    next.rutaCrystal?.trim() || prev?.rutaCrystal?.trim() || rutaRespaldo || '';

  const motorRaw = next.motor ?? prev?.motor ?? IMPRESION_MOTOR.PLANTILLA;

  return {
    motor:
      motorRaw === IMPRESION_MOTOR.CRYSTAL ? IMPRESION_MOTOR.CRYSTAL : IMPRESION_MOTOR.PLANTILLA,
    variantePlantilla:
      next.variantePlantilla ??
      prev?.variantePlantilla ??
      IMPRESION_VARIANTE.PLANTILLA_1,
    rutaCrystal,
  };
}

/** Normaliza impresión recibida del API (acepta camelCase o PascalCase). */
export function parseImpresionDesdeApi(raw: unknown): Partial<ImpresionLetraState> {
  if (!raw || typeof raw !== 'object') return {};
  const o = raw as Record<string, unknown>;
  return {
    motor: (o.motor ?? o.Motor) as ImpresionMotor | undefined,
    variantePlantilla: (o.variantePlantilla ?? o.VariantePlantilla) as string | undefined,
    rutaCrystal: String(o.rutaCrystal ?? o.RutaCrystal ?? '').trim() || undefined,
  };
}
